import { useCallback, useContext } from 'react';

import { GtmEventType } from '@gn-audio/jss-core';

import { TrackingContext } from '../../../utils/contexts/TrackingContext';

export interface SearchTrackingData {
  search_term: string;
  search_results_count?: number;
  search_type?: 'manual_search' | 'live_search';
  search_source?: 'desktop' | 'mobile';
}

export const useSearchTracking = () => {
  const { gtmEvent } = useContext(TrackingContext);

  const trackSearchEvent = useCallback(
    (data: SearchTrackingData | string) => {
      const eventData = typeof data === 'string' ? { search_term: data } : data;

      const gtmPayload = {
        event: GtmEventType.Search,
        search_term: eventData.search_term,
        ...(eventData.search_results_count !== undefined && {
          search_results_count: eventData.search_results_count,
        }),
        ...(eventData.search_type && { search_type: eventData.search_type }),
        ...(eventData.search_source && { search_source: eventData.search_source }),
      };

      gtmEvent(gtmPayload);
    },
    [gtmEvent]
  );

  return { trackSearchEvent };
};
